<template>
<div>
  
    <Header />
        
 
  <SmoothScrollLand>
  <div class="home home-true" data-scroll-section data-scroll>
      
      <router-view></router-view>
      <Footer />
  </div>
    </SmoothScrollLand>
    <CookiesBar />
    </div>
</template>

<script>
import SmoothScrollLand from '@/components/SmoothScrollLand';

import CookiesBar from "@/components/CookiesBar";

import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";

export default {
  name: "Home",
  components: {
  
  
   Header,
   SmoothScrollLand,
   CookiesBar,
   
    Footer
  },
  data() {
    return {
      components: []
    };
  },
  mounted() {
    if (this.$store.state.main.current_content_request_status === "done") {
  // console.log("done")
}
  },
  methods: {},
  watch: {
    $route:{
      handler: function(){
         
          // console.log("changed hi")
      }
    }
  }
};
</script>
